module.exports = __webpack_public_path__ + "static/map-ireland-e677413b54c1bfba8aecd6bd85af1fd5.png";